module.exports = __webpack_public_path__ + "media/packs/images/flags/TP-fd7c7055aed9389d352b40fd5bc2e2df.png";